import { buildUrl } from "../../lib/buildUrl";
import { fetchContent, postContent } from "../../lib/fetchData";

/**
 * Sets the location selection server side by calling an API
 * @param id
 */
export async function setLocationOnServerSession(id: number | null) {
  if (!id) {
    return;
  }
  const url = new URL(buildUrl("/api/session/hospital/"));
  url.searchParams.append("id", id.toString());

  const result = await fetchContent<boolean>(url.pathname + url.search);
  return result;
}

export function searchLocations(
  params: LocationSearchParams,
): Promise<Array<SimpleLocation>> {
  const url = "/api/locations/search";

  return postContent(url, params);
}
